import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'transform',
  version: '1.0.0',
  iteratesOverItems: true,
  properties: [
    {
      key: 'mode',
      label: 'Mode',
      type: 'options',
      required: true,
      default: 'each',
      options: [
        {
          value: 'each',
          name: 'Transform Each Item',
        },
        {
          value: 'all',
          name: 'Transform All Items',
        },
      ],
      description: 'Apply expression to each item or to the entire array',
    },
    {
      key: 'inputArray',
      label: 'Input Array',
      type: 'string',
      placeholder: '{{ $node["NodeName"].array }}',
      description: 'Array to transform. Leave empty to use input data automatically.',
    },
    {
      key: 'expression',
      label: 'Expression',
      type: 'string',
      required: true,
      placeholder: '{{ $node["NodeName"].expression }}',
      typeOptions: {
        rows: 5,
      },
      description: 'JavaScript expression to apply. Must return the transformed result.',
    },
    {
      key: 'expressionHelp',
      label: '',
      type: 'notice',
      default: '',
      description: `**Available variables:**
- **Each mode:** \`$json\`, \`$item\`, \`$index\` - current item and its index
- **All mode:** \`$json\`, \`items\`, \`$input\` - entire array

**Examples:**
- Extract field: \`return $json.name\`
- Add field: \`return { ...$json, total: $json.price * $json.qty }\`
- Filter: \`return items.filter(i => i.active)\``,
    },
    {
      key: 'options',
      label: 'Options',
      type: 'collection',
      default: {},
      section: 'settings',
      values: [
        {
          key: 'keepOnError',
          label: 'Keep Item on Error',
          type: 'boolean',
          default: true,
          description: 'If transformation fails, keep original item instead of failing',
        },
        {
          key: 'ignoreNull',
          label: 'Ignore Null Results',
          type: 'boolean',
          default: false,
          description: 'Filter out items where expression returns null/undefined',
        },
      ],
    },
  ],
};

export default schema;
